import React, { useState, useContext } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { ToggleButton, EditIcon } from 'wix-rich-content-toolbars-ui';

const EditHtmlButton = ({ toolbarItem, dataHook, id }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext);
  const onClick = () => {
    const componentProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      closeModal: () => modalService.closeModal(id)
    };
    const isModalOpen = modalService.isModalOpen(id);
    isModalOpen ? modalService.closeModal(id) : modalService.openModal(id, {
      componentProps,
      layout: isMobile ? "fullscreen" : "popover",
      positioning: { referenceElement, placement: "bottom" },
      noPadding: true
    });
  };
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      dataHook,
      Icon: EditIcon,
      label: t("HtmlPlugin_EditHtml_Tooltip"),
      tooltip: t("HtmlPlugin_EditHtml_Tooltip"),
      onClick,
      setRef: setReferenceElement
    }
  );
};

export { EditHtmlButton };
//# sourceMappingURL=EditHtmlButton.js.map
